import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const StoreLinksContext = createContext({ links: {}, refresh: () => {} });

export const StoreLinksProvider = ({ children }) => {
  const [links, setLinks] = useState({});
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/apps/links`);
      setLinks(data && typeof data === "object" ? data : {});
    } catch {
      setLinks({});
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return <StoreLinksContext.Provider value={{ links, refresh }}>{children}</StoreLinksContext.Provider>;
};

export const useStoreLinks = (slug) => {
  const { links } = useContext(StoreLinksContext);
  return { google: links?.[slug]?.google_play_url || "", apple: links?.[slug]?.app_store_url || "" };
};

export const useRefreshStoreLinks = () => useContext(StoreLinksContext).refresh;

export const useAppStatus = (app) => {
  const { google, apple } = useStoreLinks(app.slug);
  return google || apple ? "live" : app.status;
};
